<template>
  <view class="radio-disabled-demo">
    <view-desc>禁用选项: {{ radioValue }}</view-desc>
    <view class="cube-radio-demos">
      <cube-radio

        option="{{ radio }}"
        wx:model="{{ radioValue }}"
        wx:model-prop="value"
      >disabledOption</cube-radio>
    </view>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  data: {
    radio: {
      value: 'disabledOption',
      disabled: true
    },
    radioValue: ''
  }
})
</script>

<style lang="stylus">
// .radio-disabled-demo
//   .cube-radio-example
//     padding 5px 10px
//     box-sizing border-box
//     background-color #fff
//   .desc
//     margin-top 15px
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "view-desc": "../../components/desc/index",
      "cube-radio": "@mpxjs/mpx-cube-ui/src/components/radio/index"
    }
  }
</script>
